import { computed, defineComponent, ref } from "vue";
import { definePropType } from "@types-vue/props";
import AssetView from "./asset-view.vue";
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        /* '取消/确认'按钮loading */ loading: {
            type: Boolean,
            default: false
        },
        /* '取消/确认'按钮禁用 */ // disabled: {
        //   type: Boolean,
        //   default: false,
        // },
        /* true:多选/false:单选 */ checkbox: {
            type: Boolean,
            default: true
        },
        /* 查询 具体规则见type.t文件 */ model: {
            type: definePropType(Object),
            default: function() {}
        },
        /* 提示文案 */ message: {
            type: definePropType(String)
        },
        /** 资产弹窗支持选中规则  具体规则见type.t文件 */ rules: {
            type: definePropType(Object)
        },
        /* 默认勾选项 */ selection: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        /* 禁用全部checkbox,因为编辑器项目的的资产库需要支持禁用除选中项以外的全部素材 */ disabledCheckbox: {
            type: Boolean,
            default: false
        },
        /* 是否启用跨域 */ crossorigin: {
            type: Boolean,
            default: false
        },
        // 禁止选中的ID集合
        disabledSelectId: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        }
    },
    components: {
        AssetView: AssetView
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var multipleSelection = ref([]);
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var disabled = computed(function() {
            return !multipleSelection.value.length;
        });
        var handleSelectionChange = function(rowList) {
            multipleSelection.value = rowList;
            if (props.checkbox) {
                /* 检查数据状态 @check  多选：返回数组，无勾选时，返回[] */ emit("check", multipleSelection.value);
            } else {
                /* 检查数据状态 @check  单选：返回对象，无勾选时，返回undefined */ emit("check", multipleSelection.value[0]);
            }
        };
        var handleClose = function() {
            if (!props.loading) {
                emit("update:visible", false);
            }
        };
        var handleSubmit = function() {
            /* 提交数据  @submit  数据不符合或未勾选，应禁用按钮*/ if (props.checkbox) {
                /* 多选：返回数组*/ emit("submit", multipleSelection.value);
            } else {
                /* 单选：返回对象 */ emit("submit", multipleSelection.value[0]);
            }
        };
        return {
            dialogVisible: dialogVisible,
            disabled: disabled,
            handleSelectionChange: handleSelectionChange,
            handleClose: handleClose,
            handleSubmit: handleSubmit
        };
    }
});
